import { Component, Inject, ViewChild, OnInit, OnDestroy } from '@angular/core';
//import { NgForm } from '@angular/forms';
import _ from 'lodash';
import { moment,async }             from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchDataStore }             from '../../data-stores/mysynch.datastore';
import { MySynchConstantService }       from '../../services/mysynch.constant.service';
import { MySynchEnumerationService }    from '../../services/mysynch.enumeration.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';

@Component({
  standalone: false,
  selector:    'journal-maint',
  templateUrl: '../app/pages/journal-maint/journal-maint.view.html',
  styleUrls:  ['../app/pages/journal-maint/journal-maint.style.css']
})
export class JournalMaint implements OnInit , OnDestroy {

    private performanceContext: PerformanceContext | null = null;
    private updatePermissionCode:string = 'JOURNAL_UPDATE';
    private journalData:any	= {};
 // private returnTo:string | null = String(this.MSF.state.params.cameFrom) == 'Journal' ? 'Journal' : 'FertilityAnalysis';

    private cameFrom:string | null = String(this.MSF.state.params.cameFrom);
    private returnTo:string | null = (this.cameFrom == 'Journal'            ? 'Journal' :
                                     (this.cameFrom == 'TrendsAndTargets'   ? 'TrendsAndTargets' : 'FertilityAnalysis') );
    
    private passedId:number | null = Number(this.MSF.state.params.id);
    private editing:boolean = false;

    // subscriptions and deregister functions
    private herdChangeSubscription: any;

    canUpdate:boolean   = false;
    loading:  boolean   = true;
    hasUpdatePermission:boolean = false;
    titleVerb:string	= '';
    data:any  = {};
	valid:any = {
                  category:    true, 
                  date:        true, 
                  description: true
                }
    dateFormat:any	    = null;
	
    _:any;

    constructor(@Inject('MySynchFactory')           private MSF:any,
                @Inject('ApiFactory')               private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth,
                @Inject(MySynchEnumerationService)  private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(MySynchDataStore)           private mysynchDataStore:MySynchDataStore,
                @Inject(MySynchConstantService)     private mySynchConstantService:MySynchConstantService,
                @Inject(PerformanceMetricsService)  private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
                ){
                    this._ = _;
                }
   
    inEditMode() {
        return this.editing;
    };

    inAddMode() {
        return !this.editing;
    };

    onCategoryChange() {
        this.valid.category = this.validationCategory(this._.get(this.data,'category')) && this._.get(this.data,'category')	!= undefined;
    };

    saveJournal() {
        // -- custom validation

        this.valid.date			= this.validationNoFutureDates(this._.get(this.data,'date'));

        this.valid.category		= this.validationCategory(     this._.get(this.data,'category'))    && this._.get(this.data,'category')	!= undefined;

        this.valid.description	= this.validationDescription(  this._.get(this.data,'description')) && this._.get(this.data,'description') != undefined;

        if (!this.valid.date || !this.valid.category || !this.valid.description){
            return false;
        }

        this.journalData = {
            herdId: 		this._.get(this.data,'herdId'),
            id:				this._.get(this.data,'id'),
            userId:			this._.get(this.data,'userId'),
            category:		this._.get(this.data,'category'),
            date:			moment.parseZone(this._.get(this.data,'date')).toDate(),
            description:	this._.get(this.data,'description')
        };

        this.loading = true;

        this.api.updateJournal(_.extend({}, this.journalData),
            (err, newJournalEntry)=> {
                this.loading = false;

                if (err) {
                    return this.log.error(this.MSF.notify.danger('Error updating my journal entry ' + err));
                }

                this.log.info(this.MSF.notify.success('Changes saved successfully'));
                this.MSF.loadPage(this.returnTo);
            }
        );
    };
    newJournal() {
         // -- custom validation

        this.valid.date			= this.validationNoFutureDates( this._.get(this.data,'date'));

        this.valid.category		= this.validationCategory(      this._.get(this.data,'category')) && this._.get(this.data,'category') != undefined;

        this.valid.description	= this.validationDescription(   this._.get(this.data,'description')) && this._.get(this.data,'description')	!= undefined;


        if (!this.valid.date || !this.valid.category || !this.valid.description){
            return false;
        }

        this.journalData = {
            herdId: 		this._.get(this.data,'herdId'),
            userId:			this._.get(this.data,'userId'),
            category:		this._.get(this.data,'category'),
            date:			new Date(moment.parseZone(this._.get(this.data,'date')).toDate()),
            description:	this._.get(this.data,'description')
        };

        this.loading = true;

        this.api.createJournal(_.extend({}, this.journalData), 
           (err, newJournalEntry)=> {
                this.loading = false;

                if (err) {
                    return this.log.error(this.MSF.notify.danger('Error creating journal entry ' + err));
                }

                this.log.info(this.MSF.notify.success('Journal Entry created successfully'));
                this.MSF.loadPage(this.returnTo);
            }
        );
    };

    validationNoFutureDates(entry) {
        var isCustomValid = ( moment(entry).toDate() <= moment().subtract(moment().utcOffset(), 'minutes').toDate() &&
                              moment(entry).toDate() >= moment(new Date('2000/01/01')).toDate() );
        this.valid.date = isCustomValid;
        return isCustomValid;
    };

    validationCategory(entry) {
        var isCustomValid = true;
        if(!this._.isUndefined(entry)){
            isCustomValid  = this._.size(this._.find( this._.get(this.MSF,'lists.journalCategory'), {code: this._.get(this.data,'category')})) > 0;
        }
        this.valid.category	= isCustomValid;
        return isCustomValid;
    };

    validationDescription(entry) {
        var isCustomValid = this._.size(entry) <= 256;
        this.valid.description = isCustomValid;
        return isCustomValid;
    };
    cancel() {
        this.MSF.loadPage(this.returnTo);
    };

    ngOnDestroy(): void {
        if (this.herdChangeSubscription) {
            this.herdChangeSubscription.unsubscribe();
        }
        this.performanceContext = null;
    }
    ngOnInit() {
        this.MSF.ready(()=> {
            this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.MSF,'activeHerd.herdId', null));
            this.perfMetricSvc.startTiming('Page:JournalMaint:Render');
            this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
            if (this._.isNumber(this.passedId) && this.passedId > 0) {		// -- Editing journal item passed in via params
				this.titleVerb  = 'Edit';
				this.editing    = true;
                this.perfMetricSvc.startTiming('Page:JournalMaintPageData:Request');
				this.api.getOneJournal(this._.get(this.MSF,'activeHerd.herdId'), this.passedId, this.performanceContext, 
					(err, journalData)=>{
                        this.perfMetricSvc.startTiming('Page:JournalMaint:Build');
                        this.perfMetricSvc.endTiming("page",'Page:JournalMaintPageData:Request', this.performanceContext);
						if (err) {
                            this.perfMetricSvc.endTiming("page",'Page:JournalMaint:Build', this.performanceContext);
							return this.log.error(this.MSF.notify.danger('Error retrieving journal item ' + err));
						}
						this.data = {
							id:				this._.get(journalData,'[0].id'),
							userId:			this._.get(this.MSF   ,'cookies.user.PersonId'),
							herdId:			this._.get(journalData,'[0].herdId'),
							category:		this._.get(journalData,'[0].category'),
							description: 	this._.get(journalData,'[0].description'),
							date:			moment(this._.get(journalData,'[0].date')).subtract(moment(this._.get(journalData,'[0].date')).utcOffset(), 'minutes').format('YYYY-MM-DD'),	// editable date in UI

							viewableCreatedUser: 	this._.get(journalData,'[0].viewableCreatedUser'),
							viewableModifiedUser: 	this._.get(journalData,'[0].viewableModifiedUser'),
							viewableCreatedDate: 	moment(this._.get(journalData,'[0].viewableCreatedDate') ).format(this.dateFormat),		// readonly string UI
							viewableModifiedDate: 	moment(this._.get(journalData,'[0].viewableModifiedDate')).format(this.dateFormat)		// readonly string UI
						};

						this.loading = false;
                        this.perfMetricSvc.endTiming("page",'Page:JournalMaint:Build', this.performanceContext);
						return null;
				});
			} else {												// -- Adding new journal
                this.perfMetricSvc.startTiming('Page:JournalMaint:Build');
				this.titleVerb = 'Add';
				this.editing   = false;
				this.data 	   = {
					herdId:			this._.get(this.MSF,'activeHerd.herdId'),
					date:			moment().subtract(moment().utcOffset(), 'minutes').format('YYYY-MM-DD'),	// editable date in UI
					userId:			this._.get(this.MSF,'cookies.user.PersonId'),
					category:		'',
					description: 	''
				};
                this.loading = false;
                this.perfMetricSvc.endTiming("page",'Page:JournalMaint:Build', this.performanceContext);
			}
            this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
            if(!this.hasUpdatePermission){
                this.MSF.loadPage(this.returnTo);
            }
            this.perfMetricSvc.markPageReady('Page:JournalMaint:Render', this.performanceContext);
            this.herdChangeSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd)=>{
                if(!_.isUndefined(herd) && !this.loading){
                    this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
                    this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
					if(!this.hasUpdatePermission){
                        this.MSF.loadPage(this.returnTo);
                    }
                }
            });

        });
    }

};